module.exports = __webpack_public_path__ + "static/img/kid.65911314.png";